import { Image, ImageTrim } from '../image';
import { ImageLoading } from '@pixum/logo';
import type { ImageNode } from 'data-layer';
import type { DeviceOrientedComponentProps } from '../../types';

interface UspImageProps extends DeviceOrientedComponentProps {
  image?: ImageNode;
}

export function UspImage(props: UspImageProps) {
  const { image, device } = props;

  return (
    <div className="usp__media">
      <Image image={image} loading={ImageLoading.Lazy} device={device} trim={ImageTrim.NONE} />
    </div>
  );
}
